const MOBILE_DEVICE_PATTERN = /(android|iphone|ipad|ipod|mobile|windows phone)/i;

export const getDeviceInfo = () => {
  if (typeof navigator === 'undefined') return null;
  return navigator.userAgent || null;
};

export const resolveDeviceScope = (deviceInfo = getDeviceInfo()) => {
  const normalized = String(deviceInfo || '').trim();
  if (!normalized) {
    return 'desktop';
  }

  return MOBILE_DEVICE_PATTERN.test(normalized) ? 'mobile' : 'desktop';
};

export const getAuthDeviceContext = () => {
  const deviceInfo = getDeviceInfo();
  return {
    device_info: deviceInfo,
    device_scope: resolveDeviceScope(deviceInfo),
  };
};
